import HttpClientToken from '../../services/HttpClientToken';

import { TipoRecursoProps, defaultTipoRecurso } from '../../interfaces/catalogos/TipoRecursoInterface';

export const TipoRecursos = () => {

    return new Promise<TipoRecursoProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoRecurso/', token)
            .then( ({ data } : { data : TipoRecursoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoRecurso = () => {

    return new Promise<TipoRecursoProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoRecurso/ObtenerTipoRecursos', token)
            .then( ({ data } : { data : TipoRecursoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoRecurso = ( params: TipoRecursoProps ) => {

    return new Promise<TipoRecursoProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoRecurso/Actualizar', params, token)
            .then( ({ data } : { data : TipoRecursoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoRecurso } );
            });

        }

    });

}

export const AgregarTipoRecurso = ( params: TipoRecursoProps ) => {

    return new Promise<TipoRecursoProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoRecurso/Agregar', params, token)
            .then( ({ data } : { data : TipoRecursoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoRecurso } );
            });

        }

    });

}
